'use strict';

angular.module('shop').controller('DuplicateController', function () {});
